import TicketPart from './components/TicketPart/TicketPart'

import ButtonQuantity from 'components/Buttons/ButtonQuantity/ButtonQuantity'
import Money from '../Money/Money'
import './Goods.scss'

const GoodsWidthAmount = ({
    leftTitle = 'Title',
    description = 'description',
    price = 666,
    currency = 'Kč',
    amount = 1,
    addOne,
    removeOne,
}) => {
    return (
        <>
            <div className={'goods goods__payment'}>
                <TicketPart className={'border-radius-right border-radius-left dashed-right'}>
                    <span className="left-title ">{leftTitle}</span>
                </TicketPart>
                <TicketPart className={'border-radius-left separator-right d-flex'}>
                    <span className="left-title text-basePrimary">{description}</span>
                </TicketPart>
                <TicketPart className={'border-radius-right d-flex text-magentaSecondary'}>
                    <div className="price-and-amount">
                        <ButtonQuantity quantity={amount} onClickLeft={removeOne} onClickRight={addOne} />
                        <Money amount={price} currency={currency} />
                    </div>
                </TicketPart>
            </div>
        </>
    )
}

export default GoodsWidthAmount
